import request from '@/utils/index'

// const baseUrl = 'http://202.10.100.108:8010'
const baseUrl = 'https://device.motorjourney.cn'

// 获取个人周发帖排行
export function getPersonalPost (data) {
  return request({
    url: `${baseUrl}/board/board/userBoardForumCount`,
    method: 'GET',
    params: data
  })
}

// 获取车队周发帖排行
export function getTeamPost (data) {
  return request({
    url: `${baseUrl}/board/board/teamBoardForumCount`,
    method: 'GET',
    params: data
  })
}

// 获取个人积分(历史)周榜
export function getPersonalWeekIntegral (data) {
  return request({
    url: `${baseUrl}/board/board/userBoardWeekCount`,
    method: 'GET',
    params: data
  })
}

// 获取个人积分(历史)月榜
export function getPersonalMonthIntegral (data) {
  return request({
    url: `${baseUrl}/board/board/userBoardMonthCount`,
    method: 'GET',
    params: data
  })
}

// 获取个人积分(历史)总榜
export function getPersonalAllIntegral (data) {
  return request({
    url: `${baseUrl}/board/board/userBoardAllCount`,
    method: 'GET',
    params: data
  })
}

// 获取车队积分(历史)周榜
export function getTeamWeekIntegral (data) {
  return request({
    url: `${baseUrl}/board/board/teamBoardWeekCount`,
    method: 'GET',
    params: data
  })
}

// 获取车队积分(历史)月榜
export function getTeamMonthIntegral (data) {
  return request({
    url: `${baseUrl}/board/board/teamBoardMonthCount`,
    method: 'GET',
    params: data
  })
}

// 获取车队积分(历史)总榜
export function getTeamAllIntegral (data) {
  return request({
    url: `${baseUrl}/board/board/teamBoardAllCount`,
    method: 'GET',
    params: data
  })
}
